import { render } from "./AddPaymentIncident.vue?vue&type=template&id=1326f238"
import script from "./AddPaymentIncident.vue?vue&type=script&lang=js"
export * from "./AddPaymentIncident.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__